<template>
  <b-badge :style="badgeConfig.badgeStyle" class="adjustment-status-badge">
    {{ badgeConfig.badgeLabel }}
  </b-badge>
</template>

<script>
import { ADJUSTMENT_STATUS } from "@/constants/productStock";

export default {
  name: "AdjustmentStatusBadge",
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeConfig() {
      const TEXT_COLOR = "#3E495B";
      const configs = {
        [ADJUSTMENT_STATUS.WAITING_BM]: {
          badgeStyle: { backgroundColor: "#E3F2FD", color: TEXT_COLOR },
          badgeLabel: "รอผู้จัดการคลังอนุมัติ",
        },
        [ADJUSTMENT_STATUS.WAITING_HQ]: {
          badgeStyle: { backgroundColor: "#DBCCF4", color: TEXT_COLOR },
          badgeLabel: "รอสำนักงานใหญ่อนุมัติ",
        },
        [ADJUSTMENT_STATUS.REJECTED]: {
          badgeStyle: { backgroundColor: "#DD3333", color: "#fff" },
          badgeLabel: "ถูกปฏิเสธ",
        },
        [ADJUSTMENT_STATUS.COMPLETED]: {
          badgeStyle: { backgroundColor: "#D8EFDD", color: TEXT_COLOR },
          badgeLabel: "อนุมัติแล้ว",
        },
        [ADJUSTMENT_STATUS.CANCELED]: {
          badgeStyle: { backgroundColor: "#E9ECEF", color: TEXT_COLOR },
          badgeLabel: "ยกเลิก",
        },
      };
      return (
        configs[this.status] || {
          badgeStyle: { backgroundColor: "#E9ECEF", color: TEXT_COLOR },
          badgeLabel: "ไม่พบสถานะ",
        }
      );
    },
  },
};
</script>

<style scoped>
.adjustment-status-badge {
  font-size: 14px;
  font-weight: 400;
  padding: 0.35em 0.65em;
  border-radius: 20px;
}
</style>
